import React, {FC, useEffect, useState} from "react";
import {Button, Col, Modal, Row, Select, Form, Skeleton, notification, Tag} from "antd";
import {SelectProps} from "antd/es/select";
import {changeCmsRoles, findAllByUserId, getRoleList} from "../actions";
import {UserRolesModalProps} from "../admin-users.type";


const UserRolesModal: FC<UserRolesModalProps> = (props: UserRolesModalProps) => {
    const [isSaving, setSaving] = useState(false);
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(true);
    const [options, setOptions] = useState<SelectProps['options']>([]);
    const [isAdmin, setIsAdmin] = useState(false);

    const handleOk = () => {
        form.validateFields().then(
            () => {
                setSaving(true);

                const {roles} = form.getFieldsValue();

                changeCmsRoles(props.serviceUrl, {
                    action: "add_role",
                    roles: roles,
                    user: props.selectedUser.login,
                    userId: props.selectedUser.id,
                })
                    .then(
                        () => {
                            notification['success']({
                                message: 'Роли пользователя успешно обновлены!',
                            });
                            props.handleOk();
                            form.resetFields();
                        }
                    ).finally(() => setSaving(false));
            }
        );
    };

    const handleCancel = () => {
        props.handleCancel();
        setIsAdmin(false);
        form.resetFields();
    };

    useEffect(() => {
        if (props.selectedUser) {
            setIsLoading(true);

            Promise.all([
                getRoleList(),
                findAllByUserId(props.selectedUser.id)
            ]).then(
                ([roles, userRoles]) => {
                    if (roles.data) {
                        setOptions(roles.data.filter(x => x.id !== 1).map(x => ({
                            label: x.name.ru,
                            value: x.id,
                        })))
                    }

                    if (userRoles.data) {
                        if (userRoles.data.find(x => x.id === 1)) {
                            setIsAdmin(true);
                        } else {
                            form.setFieldValue('roles', userRoles.data.map(x => x.id));
                        }

                    }
                }
            ).finally(() => setIsLoading(false));
        }
    }, [props.selectedUser]);


    return (
        <Modal title="Права и роли пользователя"
               open={props.isModalOpen}
               onOk={handleOk}
               onCancel={handleCancel}
               width='85%'
               footer={[
                   <Button className="btn-admin" key="back" onClick={handleCancel}>
                       Отмена
                   </Button>,
                   (!isAdmin && !isLoading) && (
                       <Button key="submit" type="primary" className="btn-admin" onClick={handleOk} loading={isSaving}>
                           Сохранить
                       </Button>
                   )
               ]}
        >
            {isLoading ? (
                <Skeleton />
            ) : (
                <div className="user-roles">
                    {isAdmin ? (
                        <Tag color="#108ee9">Админстратор</Tag>
                        ) : (
                        <Form layout="vertical" form={form}>
                            <Row className="mt-3">
                                <Col span="24">
                                    <Form.Item
                                        label="Роли"
                                        name="roles"
                                    >
                                        <Select
                                            className="w-100"
                                            mode="multiple"
                                            allowClear
                                            optionFilterProp="label"
                                            placeholder="Выберите роль"
                                            options={options}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    )}
                </div>
            )}
        </Modal>
    );
};

export default UserRolesModal;
